import React, {useCallback, useContext, useState} from 'react';
import {Title, Text, Flex} from '@priority-software/priority-style-react';
import {OnboardingCtx} from '../../Onboarding.context';
import {Content} from '../TabsContent/Content';
import {Footer} from '../TabsContent/Footer';
import {FormMessage} from '../../components/FormMessage';
import {SubmitButton} from '../../components/SubmitButton';
import {ReactComponent as Logo} from './priority-logo-black.svg';
import {OnboardingTabsContext} from '../TabsContent';
import {setOnboardingCompleted} from '../../service/completionState';
import {summaryService} from './summary.service';
import {tabsTitleMap} from '../../constants';
import {showErrorToast} from '../../../../components/Toast/actions/ToastActions';
import texts from '../../texts';
import styles from './styles.module.scss';
import {sendMonitor} from '../../../../utils/monitoring';

export const Summary = () => {
    const {tabs: tabsList, goToTab} = useContext(OnboardingTabsContext);
    const {close_OB_dialog} = useContext(OnboardingCtx);
    const [loadingSummaryReport, setLoadingSummaryReport] = useState(false);

    const notFinishedSteps = tabsList.slice(0, -1).filter(item => !item.ready);
    const isFinished = notFinishedSteps.length === 0;

    const onViewSummary = useCallback(async () => {
        sendMonitor('OnboardingTabsSummaryReport');
        try {
            setLoadingSummaryReport(true);
            await summaryService.startAction();
            setLoadingSummaryReport(false);
        } catch (e) {
            setLoadingSummaryReport(false);
            showErrorToast((e as Error).message);
        }
    }, [setLoadingSummaryReport]);

    const onComplete = useCallback(async () => {
        sendMonitor('OnboardingTabsSummaryDone');
        await setOnboardingCompleted();
        close_OB_dialog();
    }, [close_OB_dialog]);

    return (
        <>
            <Content>
                <div className={styles.component}>
                    <div className="tabHeader">
                        <Title skin="h2" textColor="primary-500" componentClasses="tabTitle">
                            {texts.summary_tab_title}
                        </Title>

                        {isFinished && (
                            <Title
                                skin="h5"
                                textColor="primary-700"
                                componentClasses={styles.subtitle}
                            >
                                {texts.summary_tab_subtitle}
                            </Title>
                        )}

                        <Text textColor="primary-700" componentClasses={styles.subtext}>
                            {texts.summary_tab_subtext}
                        </Text>
                    </div>

                    {isFinished ? (
                        <div>
                            <Text tag="p" textColor="primary-700">
                                {texts.summary_tab_success_text}
                            </Text>

                            <Title
                                skin="h5"
                                textColor="primary-700"
                                componentClasses={styles.signature}
                            >
                                {texts.summary_tab_signature}

                                <Logo className={styles.signatureLogo} />
                            </Title>
                        </div>
                    ) : (
                        <div>
                            <Text
                                componentClasses={styles.listTitle}
                                tag="div"
                                textColor="primary-700"
                                skin="subtitle-1"
                            >
                                {texts.summary_tab_list_title}
                            </Text>

                            <ul className={styles.stepsList}>
                                {notFinishedSteps.map(item => {
                                    return (
                                        <li key={item.id}>
                                            <div
                                                className={styles.link}
                                                onClick={goToTab}
                                                id={item.id}
                                            >
                                                <Text componentClasses={styles.linkText}>
                                                    {tabsTitleMap[item.id]}
                                                </Text>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}

                    <FormMessage
                        componentClasses={styles.formMessage}
                        loading={loadingSummaryReport}
                        btnHandler={onViewSummary}
                        btnText={texts.summary_tab_message_btn}
                        text={texts.summary_tab_message}
                    />
                </div>
            </Content>

            <Footer>
                <Flex justifyContent="flex-end">
                    <SubmitButton componentClasses={styles.submit} onClick={onComplete}>
                        {texts.summary_tab_btn}
                    </SubmitButton>
                </Flex>
            </Footer>
        </>
    );
};
